import appConfig from '../config/appConfig';

const MINOR_UNIT_FACTOR = 100;
const CURRENCY_SYMBOL = appConfig.stripeCurrency || '$';

export function toMinorAmount(value) {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return value;
  }

  return Math.round(numericValue * MINOR_UNIT_FACTOR);
}

export function toMajorAmount(value) {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return value;
  }

  return numericValue / MINOR_UNIT_FACTOR;
}

export function normalizeTiersToMajorAmount(tiers = []) {
  return tiers.map((tier) => ({
    ...tier,
    unit_amount: toMajorAmount(tier.unit_amount),
    flat_amount: toMajorAmount(tier.flat_amount),
  }));
}

export function normalizeTiersToMinorAmount(tiers = []) {
  return tiers.map((tier) => ({
    ...tier,
    unit_amount: toMinorAmount(tier.unit_amount),
    flat_amount: toMinorAmount(tier.flat_amount),
  }));
}

export function formatMinorToMajorAmount(value, options = {}) {
  const { emptyValue = '-', currencySymbol = CURRENCY_SYMBOL } = options;

  if (value === null || value === undefined || value === '') {
    return emptyValue;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return emptyValue;
  }

  return `${currencySymbol} ${toMajorAmount(numericValue).toFixed(2)}`;
}
